import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete } from '@/api/PMS/estateManagement/notice/noticeType';
import waves from '@/directive/waves'; // 水波纹指令

import noticeTypeAdd from './add';
export default {
  name: 'ComplexTable',
  components: {
    noticeTypeAdd: noticeTypeAdd
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10
      },
      title: '',
      noticeTypeId: -1,
      multipleSelection: [],
      dialogFormVisible: false
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.noticeTypeId = -1;
      this.title = '创建';
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(noticeTypeId) {
      this.noticeTypeId = noticeTypeId;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    delete: function _delete(noticeTypeIds) {
      var _this2 = this;

      if (noticeTypeIds.length > 0) {
        this.$confirm('你确定是要删除这些通知类型, 是否继续?', '提示').then(function () {
          fetchDelete(noticeTypeIds).then(function (response) {
            if (response.data.code === 200) {
              _this2.getList();

              _this2.Alert({
                alertType: 'delete'
              });
            }
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(noticeTypeId) {
      var noticeTypeIds = [];
      noticeTypeIds.push(noticeTypeId);
      this.delete(noticeTypeIds);
    },
    handleDeletes: function handleDeletes() {
      var noticeTypeIds = [];
      this.multipleSelection.forEach(function (row) {
        noticeTypeIds.push(row.noticeTypeId);
      });
      this.delete(noticeTypeIds);
    }
  }
};